import cx from 'classnames';
import React, { forwardRef } from 'react';

export interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const Textarea = forwardRef<HTMLTextAreaElement, Props>(function X({ className, rows = 4, ...props }, ref) {
  return <textarea {...props} className={cx('dtUiInput', className)} ref={ref} rows={rows} />;
});
